/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import update from 'immutability-helper';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import { CLEAR_REDUX_DATA_ERRORS } from 'globalActionCreators';

export const globalReducer = (state = {}, action) => {
  if (action.type === CLEAR_REDUX_DATA_ERRORS) {
    const reduxPath = action.payload;
    if (isNil(state[reduxPath])) {
      return state;
    }

    const updatedReduxPath = update(state[reduxPath], {
      $merge: {
        updateDataError: null,
        fetchDataError: null,
      },
    });
    return update(state, { [reduxPath]: { $set: updatedReduxPath } });
  }
  return state;
};

// Global Selectors
export const isDataLoading = (state, reduxPath) => get(state, [reduxPath, 'fetchingData']);

export const isDataUpdating = (state, reduxPath) => get(state, [reduxPath, 'updatingData']);

export const getData = (state, reduxPath) => {
  const data = get(state, [reduxPath, 'data']);
  // filter out any records that are actively being deleted
  if (Array.isArray(data)) {
    return data;
  }
  return data
    ? Object.values(data).filter(dataToCheck => dataToCheck && !dataToCheck.isDeleting)
    : [];
};

export const getDataError = (state, reduxPath) =>
  get(state, [reduxPath, 'updateDataError']) || get(state, [reduxPath, 'fetchDataError']);

export const getFetchError = (state, reduxPath) => get(state, [reduxPath, 'fetchDataError']);

export const getUpdateError = (state, reduxPath) => get(state, [reduxPath, 'updateDataError']);
